// extracted by mini-css-extract-plugin
module.exports = {"root":"input_root__TQmNF","primary":"input_primary__0NcJf","error":"input_error__LfYxh"};